export enum CategoryKey {
  // Same name of the folder in the public/press-kit folder
  // Same name of the route in the src/views/press-kit/[CategoryKey].tsx
  MediaGallery = 'media-gallery',
  VideoLibrary = 'video-library',
  OurLogos = 'our-logos',
  Team = 'team',
  PressReleases = 'press-releases',
}

type Category = {
  key: CategoryKey;
  title: { [key: string]: string };
  image: string;
  description: { [key: string]: string };
  sectionText?: { [key: string]: string };
};

const PressKitCategories: Category[] = [
  {
    key: CategoryKey.MediaGallery,
    title: { 'pt-BR': 'Galeria de Mídia', 'en-US': 'Media Gallery' },
    image: '/press-kit/banners/GALERIA DE MÍDIA.png',
    description: {
      'pt-BR': 'Descubra uma coleção abrangente de imagens para uso institucional.',
      'en-US': 'Discover a comprehensive collection of images for institutional use.',
    },
    sectionText: {
      'pt-BR':
        'Seja bem-vindo à nossa Galeria de Mídia, onde você encontrará uma seleção de screenshots de nosso App que mostram algumas funcionalidades.\nUse essas imagens para enriquecer suas matérias e ilustrar sua redação.',
      'en-US':
        'Welcome to our Media Gallery, where you will find a selection of screenshots from our App that show some of its features.\nUse these images to enrich your articles and illustrate your writing.',
    },
  },
  {
    key: CategoryKey.VideoLibrary,
    title: { 'pt-BR': 'Videoteca', 'en-US': 'Video Library' },
    image: '/press-kit/banners/VIDEOTECA.jpg',
    description: {
      'pt-BR':
        'Tenha acesso a uma seleção de vídeos, explore e entenda as funções do App com nossos tutoriais',
      'en-US':
        'Access a selection of videos, explore and understand the functions of our App with our tutorials',
    },
    sectionText: {
      'pt-BR':
        'Nossa videoteca armazena vídeos tutoriais que explicam as funcionalidades do App.\nCaso tenha dúvidas sobre alguma função ou deseje detalhar o funcionamento do App, acesse ao tutorial desejado.',
      'en-US':
        'Our video library stores videos tutorials that explain the functions of our App.\nIf you have any questions about a function or want to detail how the App works, access the desired tutorial.',
    },
  },
  {
    key: CategoryKey.OurLogos,
    title: { 'pt-BR': 'Nossos Logos', 'en-US': 'Our Logos' },
    image: '/press-kit/banners/LOGOS.png',
    description: {
      'pt-BR': 'Acesse nossa identidade visual oficial para uso corporativo.',
      'en-US': 'Access our official visual identity for corporate use.',
    },
    sectionText: {
      'pt-BR':
        'Aqui, nós disponibilizamos as versões oficiais da nossa identidade visual, prontas para download. Se você precisa do nosso logotipo para materiais de comunicação, marketing ou publicações, este é o lugar certo. Garantimos que todas as versões estão em alta qualidade, adequadas para uso em diferentes mídias, mantendo sempre a integridade de nossa marca.',
      'en-US':
        'Here, we provide the official versions of our visual identity, ready for download. If you need our logo for communication materials, marketing or publications, this is the right place. We guarantee that all versions are in high quality, suitable for use on different media, always maintaining the integrity of our brand.',
    },
  },
  {
    key: CategoryKey.Team,
    title: { 'pt-BR': 'Equipe', 'en-US': 'Team' },
    image: '/press-kit/banners/EQUIPE.png',
    description: {
      'pt-BR': 'Conheça os profissionais que lideram nossa empresa.',
      'en-US': 'Get to know the professionals who lead our company.',
    },
    sectionText: {
      'pt-BR':
        'Conheça a equipe por trás do nosso projeto, composta por especialistas de diferentes áreas, apaixonados por vinhos e comunicação. Cada membro traz uma bagagem única, contribuindo para a construção de um ambiente onde o conhecimento sobre vinhos seja acessível e envolvente.',
      'en-US':
        'Get to know the team behind our project, composed of experts from different areas, passionate about wine and communication. Each member brings a unique background, contributing to the construction of an environment where knowledge about wine is accessible and engaging.',
    },
  },
  {
    key: CategoryKey.PressReleases,
    title: { 'pt-BR': 'Releases', 'en-US': 'Releases' },
    image: '/press-kit/banners/PRESS RELEASES.png',
    description: {
      'pt-BR': 'Fique por dentro das últimas notícias e atualizações da nossa empresa.',
      'en-US': 'Stay informed about the latest news and updates from our company.',
    },
    sectionText: {
      'pt-BR':
        'Nesta seção, você encontrará nossos <i><b>press releases</b></i>, preparados para mantê-lo informado sobre as novidades, eventos e lançamentos em primeira mão. Fique à vontade para explorar nossos releases e utilize-os para suas pautas, garantindo que a informação correta sobre nossa empresa chegue ao seu público de maneira clara e precisa.',
      'en-US':
        'In this section, you will find our <i><b>press releases</b></i>, prepared to keep you informed about news, events and releases in the first person. Feel free to explore our releases and use them for your agendas, ensuring that the correct information about our company reaches your audience in a clear and accurate way.',
    },
  },
];

export default PressKitCategories;
